"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  color: ", ";\n  font-size: 1.125em;\n  letter-spacing: .05em;\n  line-height: 1.125;\n  text-transform: uppercase;\n"], ["\n  border-bottom: ", ";\n  color: ", ";\n  font-size: 1.125em;\n  letter-spacing: .05em;\n  line-height: 1.125;\n  text-transform: uppercase;\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _arenaConfig = require("arena-config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SectionTitle = _styledComponents2.default.div(_templateObject, _arenaConfig.DASHED_BORDER, _arenaConfig.LIGHT_GRAY);

exports.default = SectionTitle;